//@ts-check
import React, { useRef, useEffect } from "react"
import DeleteIcon from "@material-ui/icons/Delete"
import IconButton from "@material-ui/core/IconButton"
import AddIcon from "@material-ui/icons/Add"
import Button from "@material-ui/core/Button"
import Tooltip from "./tooltip"
import AddressInput from "./address-input"
import { Input } from "./input"
//@ts-ignore
import _ from "lodash"
import ValueOrChoose from "./value-or-choose"
import BytesInput from "./bytes-input.js"
import store, { qs } from "../store"
import { useStepIndex } from "./step-index-context"
import { defForType } from "../../../shared/default-parameters-for-abi-inputs"

/**
 * @param props {object}
 * @param props.type {string}
 * @param [props.width] {any}
 * @param [props.disabled] {any}
 * @param [props.wrapperWidth] {any}
 * @param props.value {any}
 * @param props.onChange {any}
 * @param [props.hideType] {boolean}
 * @param [props.components] {{components,type,name}[]}
 * @param [props.label] {string}
 * @param [props.labelBackground] {string?}
 * @param [props.moreOptions] {JSX.Element?}
 * @param [props.steps] {scr.Step[]}
 * @param [props.optional] {boolean}
 * @param [props.grow] {boolean}
 * @param [props.hint] {string}
 * @param [props.autofocus] {boolean?}
 * @param [props.children]
 * @param [props.showMaxButton=true] {boolean}
 */

export default function ParameterInput(props) {
  var tooltipText
  var isOneSide=store.getView()=="oneside"
  if (props.type == "address") {
    tooltipText = "Choose or enter an address"
  } else {
    tooltipText = "uint value must be..."
  }
  var stepIndex=useStepIndex()
  store.useRerenderIfChange(()=>[
    store.steps[stepIndex].parameters
  ])
  var multiArrayRegExp = /^(.+\[([0-9]*)\]\[([0-9]*)\])/
  var arrayRegExp = /^(.+)\[([0-9]*)\]$/
  if (props.type.match(multiArrayRegExp)) {
    var [match, type, number] = props.type.match(arrayRegExp)
    return (
      <MultiInput
        {...props}
        value={props.value}
        type={type}
        fixed={!!number}
        numOfItems={parseInt(number)}
        moreOptions={props.moreOptions}
      />
    )
  } else if (props.type.match(arrayRegExp)) {
    var [match, type, number] = props.type.match(arrayRegExp)
    return (
      <MultiInput
        {...props}
        value={props.value}
        type={type}
        fixed={!!number}
        numOfItems={parseInt(number)}
        moreOptions={props.moreOptions}
      />
    )
  }
  if(props.components) {
    return <div>{props.components.map((x,index)=>
    <div key={index}>
    <ParameterInput
        {...props}
        type={x.type}
        components={x.components}
        value={props.value?.[index]}
        label={props.label + '.' + x.name}
        labelBackground={props.labelBackground}
        onChange={e=>{
          var newValue=e.target.value
          var value=props.value || []
          value=[...value]
          value[index]=newValue
          console.log({value})
          props.onChange({target:{value}})
        }}
        />
    </div>)}</div>
  }
  return (
    <div
      css={`
        display: inline-block;
        vertical-align: middle;
        min-width: 100%;
      `}
    >
      {props.type == "address" && <AddressInput {...props} />}
      {props.type.match(/int/) && <UINTInput {...props} />}
      {props.type.match(/ether/) && <EtherInput {...props} />}
      {props.type.match(/bytes/) && <BytesInput {...props} />}
      {props.type.match(/bool/) && <BOOLInput {...props} />}
      {props.type.match(/json/) && <JSONInput {...props} />}
      {props.type.match(/timestamp/) && <DateInput {...props} />}
      {props.type.match(/string/) && (
        <STRINGInput labelBackground={props.labelBackground} label={props.label} {...props} />
      )}
      {props.type.match(/multilinetext/) && (
        <STRINGInput labelBackground={props.labelBackground} label={props.label} {...props} multiline={true}/>
      )}
      {!isOneSide &&
      <div
        css={`
          display: inline-block;
          font-size: 0.75rem;
          color: #2E2E38;
          margin-top: 4px;
          font-weight: 300;
        `}
      >{!isOneSide && !props.hideType && props.type} {props.hint && `(${props.hint})`}</div>}
    </div>
  )
}

function STRINGInput(props) {
  var value = props.value
  return <Input {...props} value={value} placeholder="ABC..." />
}
function UINTInput(props) {
  var value = String(props.value)
  // value = value?.replace(/[^0-9]/g, "")
  // console.log('UINTINPUT',{props})
  if(props.type.match(/uint/)) {
    var bits=props.type.replace(/uint/,'') // 8/256
    var maxValue=BigInt(2**bits)-1n
  } else if(props.type.match(/int/)) {
    var bits=props.type.replace(/int/,'') // 8/256
    var maxValue=BigInt(2**bits/2)-1n
  }
  return <div css={`display:flex;align-items:center;`}>
  <div css={`flex-grow:1;`}>
  <Input 
      {...props} 
      isValidFunc={x=>{
        if(!x.match(/^[0-9]{1,}$/)) return false
        if(x && BigInt(x)>maxValue) return false
        return true
      }}
      maxValue={String(maxValue)}
      value={value}
      placeholder="0..." />
  </div>
  </div>
}
function JSONInput(props) {
  
  function changeValue(value){
    props.onChange({target:{value}})
  }
  return <div css={`display:flex;align-items:center;`}>
  <div css={`flex-grow:1;`}>
  <Input 
      {...props} 
      width='100%'
      onChange={e=>changeValue(e.target.value)}
      multiline
      isValidFunc={x=>{
        try {
          JSON.parse(x)
          return true
        }  catch(err){
          return false
        }
      }}
      value={props.value}
      placeholder="[...]" />
  </div>
  </div>
}
function EtherInput(props) {
  var value = String(props.value)
  // value = value?.replace(/[^0-9]/g, "")
  return <Input 
  {...props} 
  isValidFunc={x=>{
    return x.match(/^[0-9.]{1,}$/)
  }}
  value={value}
  placeholder="0..." />
}
function BOOLInput(props) {
  let value = props.value;
  if(props.value === true) {
    value = '1';
  }
  if(props.value === false) {
    value = '0';
  }

  return <Input
  {...props}
  onChange={e=>{
    console.log("e", e.target.value);
    let newVal = '';
    if(e.target.value=='1') {
      // @ts-ignore
      newVal = true;
    }
    if(e.target.value=='0') {
      // @ts-ignore
      newVal = false;
    }
    props.onChange({
      target:{
        value: newVal
      }
    })
  }}
  isValidFunc={x=>{
    return x.match(/^[0-1]$/)
  }}
  value={value}
  placeholder="enter 0 or 1"
  />
}

function DateInput(props) {
  return <Input
  {...props}
  type="datetime-local"
  isValidFunc={x=>{
    console.log({x})
    return !!x
  }}
  onChange={e=>{
    props.onChange({
      target:{
        value:new Date(e.target.value).valueOf()/1000
      }
    })
  }}
  value={require('moment')((props.value && props.value*1000) || null).format("YYYY-MM-DDTHH:mm")}
  />
}
function MultiInput({ fixed = false, numOfItems = 0, ...props }) {
  var stepIndex=useStepIndex()
  store.useRerenderIfChange(()=>[
    store.steps[stepIndex].parameters
  ])

  function onChange(index, e) {
    var v = e.target ? e.target.value : e
    _.set(props.value, index, v)
    updateValue(props.value)
  }
  function updateValue(newValue) {
    props.onChange({ target: { value: newValue } })
  }
  function addNew() {
    if(props.type.match(/int/)) {
      props.value.push(0)
    } else if(props.type.match(/address/)) {
      props.value.push('0xaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa')
    } else if (props.type.match(/tuple/)){
      props.value.push(
          props.components.map(x=>defForType(x.type,x.components))
      )
    } else {
      props.value.push('')
    }
    try {
      updateValue([...props.value])
    } catch(err) {
      console.log('it is not an array')
      updateValue(props.value)
    }

  }
  function remove(index) {
    props.value.splice(index, 1)
    updateValue(props.value)
  }
  if (!Array.isArray(props.value)) {
    props.value = []
  }
  if (!fixed) {
    numOfItems = props.value.length
  }
  var style = {
    // paddingTop: 20,
    // paddingLeft: 10,
    paddingBottom: 10,
    // paddingRight: 10,
    fontSize: 16,
    outline: "none",
    // minWidth: 450,
    background: "inherit",
    // border: "1px solid #222",
    ...(props.style || {}),
  }

  var isOneSide=store.getView()=="oneside"
  return (
    <div style={{
      position: isOneSide ?  undefined : "relative",
      display:isOneSide ? 'flex' : 'inline-block',
      width: "100%" }}>
      {isOneSide && <div css={`width:110px;vertical-align:middle;flex-shrink:0;padding-top:0px;`}>{props.label}</div>}
      {!isOneSide && <div
        style={{
          position: "absolute",
          background: props.labelBackground || "white", //rgb(246, 246, 250)
          left: 10,
          top: -10,
          fontSize: "0.75rem",
        }}
      >
        &nbsp;{props.label} (Array)&nbsp;&nbsp;
      </div>}
      <div style={style}>
        {_.range(0, numOfItems).map(x => (
          <div style={{ marginTop: 8, marginBottom: 16, display: "flex"}}>
            <ValueOrChoose
              {...props}
              wrapperStyling={{ flex: 1 }}
              type={props.type}
              label={props.label + " #" + x}
              labelBackground={props.labelBackground}
              value={_.get(props.value, x)}
              onChange={onChange.bind(null, x)}
              setValueOfChoose={() => { }}
            />
            {!fixed && (
              <div>
                <IconButton
                  aria-label="delete" 
                  size="small"
                  onClick={remove.bind(null, x)}
                >
                  <DeleteIcon />
                </IconButton>
              </div>
            )}
          </div>
        ))}
        {!fixed && (
          <div style={{ cursor: "pointer", marginTop: 8, marginBottom: 8 }}>
              <Button
                onClick={addNew}
                variant="contained"
                color="primary"
                size="small"
                startIcon={<AddIcon />}
              >
                Add {props.type} to the array
              </Button>
          </div>
        )}
      </div>
    </div>
  )
}
